export enum EditorTool {
    Select,
    Move,
    Cut,
    AddPoint,
    DelPoint,
    invalid,
}
